import { render, staticRenderFns } from "./AtendimentoLpsList.vue?vue&type=template&id=14d9a51b&scoped=true"
import script from "./AtendimentoLpsList.vue?vue&type=script&lang=js"
export * from "./AtendimentoLpsList.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoLpsList.vue?vue&type=style&index=0&id=14d9a51b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d9a51b",
  null
  
)

export default component.exports